const translation = {
  common: {
    appUnavailable: 'แอพไม่พร้อมใช้งาน',
    appUnknownError: 'แอพไม่พร้อมใช้งาน',
    welcome: '',
  },
  chat: {
    newChat: 'แชทใหม่',
    pinnedTitle: 'ปัก หมุด',
    unpinnedTitle: 'แมว',
    newChatDefaultName: 'การสนทนาใหม่',
    resetChat: 'รีเซ็ตการสนทนา',
    poweredBy: 'รับพลังมาจาก',
    prompt: 'พร้อมท์',
    privatePromptConfigTitle: 'การตั้งค่าการสนทนา',
    publicPromptConfigTitle: 'พรอมต์เริ่มต้น',
    configStatusDes: 'ก่อนเริ่ม คุณสามารถแก้ไขการตั้งค่าการสนทนาได้',
    configDisabled: 'มีการใช้การตั้งค่าเซสชันก่อนหน้านี้สําหรับเซสชันนี้',
    startChat: 'เริ่มแชท',
    privacyPolicyLeft: 'โปรดอ่าน',
    privacyPolicyMiddle: 'นโยบายความเป็นส่วนตัว',
    privacyPolicyRight: 'จัดทําโดยนักพัฒนาแอป',
    deleteConversation: {
      title: 'ลบการสนทนา',
      content: 'คุณแน่ใจหรือไม่ว่าต้องการลบการสนทนานี้?',
    },
    tryToSolve: 'พยายามแก้',
    temporarySystemIssue: 'ขออภัย ปัญหาระบบชั่วคราว',
    expand: 'ขยาย',
    collapse: 'ย่อ',
    newChatTip: 'อยู่ในแชทใหม่แล้ว',
    chatSettingsTitle: 'การตั้งค่าการสนทนาใหม่',
    viewChatSettings: 'ดูการตั้งค่าการแชท',
    chatFormTip: 'การตั้งค่าแชทไม่สามารถเปลี่ยนแปลงได้หลังจากที่แชทเริ่มต้นขึ้นแล้ว.',
  },
  generation: {
    tabs: {
      create: 'เรียกใช้ครั้งเดียว',
      batch: 'เรียกใช้แบทช์',
      saved: 'บันทึก',
    },
    savedNoData: {
      title: 'คุณยังไม่ได้บันทึกผลลัพธ์!',
      description: 'เริ่มสร้างเนื้อหา และค้นหาผลลัพธ์ที่บันทึกไว้ที่นี่',
      startCreateContent: 'เริ่มสร้างเนื้อหา',
    },
    title: 'ความสมบูรณ์ของ AI',
    queryTitle: 'เนื้อหาแบบสอบถาม',
    completionResult: 'ผลการเสร็จสมบูรณ์',
    queryPlaceholder: 'เขียนเนื้อหาแบบสอบถามของคุณ...',
    run: 'ประหารชีวิต',
    copy: 'ลอก',
    resultTitle: 'ความสมบูรณ์ของ AI',
    noData: 'AI จะให้สิ่งที่คุณต้องการที่นี่',
    csvUploadTitle: 'ลากและวางไฟล์ CSV ของคุณที่นี่ หรือ',
    browse: 'เล็ม',
    csvStructureTitle: 'ไฟล์ CSV ต้องสอดคล้องกับโครงสร้างต่อไปนี้:',
    downloadTemplate: 'ดาวน์โหลดเทมเพลตที่นี่',
    field: 'สนาม',
    batchFailed: {
      info: '{{num}} การดําเนินการที่ล้มเหลว',
      retry: 'ลอง',
      outputPlaceholder: 'ไม่มีเนื้อหาเอาต์พุต',
    },
    errorMsg: {
      empty: 'กรุณาป้อนเนื้อหาในไฟล์ที่อัปโหลด',
      fileStructNotMatch: 'ไฟล์ CSV ที่อัปโหลดไม่ตรงกับโครงสร้าง',
      emptyLine: 'แถว {{rowIndex}} ว่างเปล่า',
      invalidLine: 'แถว {{rowIndex}}: ค่า {{varName}} ต้องว่างเปล่าไม่ได้',
      moreThanMaxLengthLine: 'แถว {{rowIndex}}: ค่า {{varName}} ต้องไม่เกิน {{maxLength}} อักขระ',
      atLeastOne: 'โปรดป้อนอย่างน้อยหนึ่งแถวในไฟล์ที่อัปโหลด',
    },
    execution: 'การดำเนินการ',
    executions: '{{num}} การประหารชีวิต',
  },
  login: {
    backToHome: 'กลับไปที่หน้าแรก',
  },
}

export default translation
